import React, { useState } from 'react';
import { X } from 'lucide-react';
import { auditService } from '../auditService';

interface CreateProgrammeModalProps {
  onClose: () => void;
  onSuccess: () => void;
}

export const CreateProgrammeModal: React.FC<CreateProgrammeModalProps> = ({
  onClose,
  onSuccess,
}) => {
  const [title, setTitle] = useState('Annual Airline Safety & Quality Audit Programme 2027');
  const [year, setYear] = useState(2027);
  const [periodStart, setPeriodStart] = useState('2027-01-01');
  const [periodEnd, setPeriodEnd] = useState('2027-12-31');
  const [ownerId, setOwnerId] = useState('QUALITY_DIRECTOR');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      await auditService.createProgramme({
        title,
        year: Number(year),
        periodStart,
        periodEnd,
        ownerId,
        items: [
          {
            targetDepartment: 'Flight Operations',
            targetDomain: 'Flight Operations',
            auditType: 'INTERNAL',
            estimatedQuarter: 'Q1',
            riskScore: 2,
            priority: 'HIGH',
          },
          {
            targetDepartment: 'Continuing Airworthiness (CAMO)',
            targetDomain: 'CAMO & Maintenance',
            auditType: 'INTERNAL',
            estimatedQuarter: 'Q2',
            riskScore: 2,
            priority: 'HIGH',
          },
        ],
      });
      onSuccess();
    } catch (err: any) {
      alert('Failed to create audit programme: ' + (err?.message || err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-card modal-lg">
        <div className="modal-header">
          <div className="modal-header-content">
            <h3>Create Annual Audit Programme</h3>
            <p>
              Define multi-department audit schedule and oversight governance.
            </p>
          </div>
          <button
            onClick={onClose}
            className="modal-close-btn"
            title="Kapat"
            aria-label="Kapat"
          >
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minHeight: 0 }}>
          <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div className="form-field">
              <label>Programme Title *</label>
              <input
                type="text"
                required
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="e.g. Annual Airline Safety & Quality Audit Programme 2027"
              />
            </div>

            <div className="form-grid-2">
              <div className="form-field">
                <label>Audit Year *</label>
                <input
                  type="number"
                  required
                  value={year}
                  onChange={(e) => setYear(Number(e.target.value))}
                />
              </div>

              <div className="form-field">
                <label>Programme Owner ID *</label>
                <input
                  type="text"
                  required
                  value={ownerId}
                  onChange={(e) => setOwnerId(e.target.value)}
                  placeholder="e.g. QUALITY_DIRECTOR"
                />
              </div>
            </div>

            <div className="form-grid-2">
              <div className="form-field">
                <label>Period Start Date *</label>
                <input
                  type="date"
                  required
                  value={periodStart}
                  onChange={(e) => setPeriodStart(e.target.value)}
                />
              </div>

              <div className="form-field">
                <label>Period End Date *</label>
                <input
                  type="date"
                  required
                  value={periodEnd}
                  onChange={(e) => setPeriodEnd(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              onClick={onClose}
              className="btn-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary"
              style={{ width: 'auto' }}
            >
              {loading ? 'Creating...' : 'Create Programme'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateProgrammeModal;
